export const mapSectionItemToFormPayload = (
  item: any,
  mainJournalData: any,
) => {
  return {
    mainJournalId: mainJournalData?.mainJournal?.mainJournalId,
    section1Id: mainJournalData?.mainJournal?.section1?.sectionId || "",
    section1ListId: mainJournalData?.mainJournal?.section1?.sectionListId || "",

    company: {
      companyId: item.company?.companyId || "",
      projectParticipantId: item.company?.projectParticipantId || "",
    },

    userCompany: {
      userCompanyHistoryId: item?.userCompany?.userCompanyHistoryId || "",
      userId: item.userCompany?.user?.userId || "",
    },

    workType: item.workType || null,
    dateStart: new Date(item.dateStart).toISOString(),
    dateEnd: item.dateEnd ? new Date(item.dateEnd).toISOString() : null,
    signer: item.signer?.userId || "",
    itemNoVersionId: item?.itemNoVersionId || "",
    status: item?.status || null,
  };
};
